/* eslint-disable max-lines */ import { LobbyImage } from '@colonist/types';
import { createDivIn, createExternalImgIn, createHeaderIn, createImgIn, createParagraphIn, setElementInnerText, setElementOnClick } from '../../ui_utils/DomUtils.ts';
import { UIProgressBadgeElement } from './UIProgressBadgeElement.ts';
import { UIProgressBarElement } from './UILockedProgressBarElement.ts';
import IconPlayTime from '@static/images/icon_playtime.svg';
import IconPlayerCount from '@static/images/icon_player_count.svg';
import IconBotCount from '@static/images/icon_bot_count.svg';
import { BotDifficulty, BotsMatchType, isBotDifficultyMatchType, isBotMatchType, MatchmakingMatchTypes } from '@colonist/game-base-types';
import { getMatchTypeDetails, getMatchTypeEligibilityAndCreatePopup, getGameModeStringForAnalytics, trackMatchmakingTimeToQueueStart, getMatchTypePlayTime, getClientCKRankedState, getMatchTypePlayerAndBotCount, updateMatchmakingPlayButtonState, isMatchTypeCasualLocked, getCasualRedirectMatchType } from '../../matchmaking/MatchmakingUtilsClient.ts';
import { UIAjaxWrapper } from '../../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../../network/UIAPIEndpoints.ts';
import { StorageWrapper } from '../../StorageWrapper.ts';
import { ClientUserState } from '../../ClientUserState.ts';
import { createDeferredPromise, TimeUtils } from '@colonist/utils';
import { createShuffleQueueIconStack } from '../../matchmaking/ShuffleQueueUtils.ts';
import { RankedConstants } from '../../../../../shared/GameEnums.ts';
import { ClientShuffleQueueController } from '../../shuffle/ClientShuffleQueueController.ts';
import { showFreePlayDiceRollDialog } from '../../ui_popup/showFreePlayDiceRollDialog.ts';
import { showRushRulesDialog } from '../../ui_popup/showRushRulesDialog.ts';
import { CKRankedState } from '../../../../../shared/matchmaking/MatchmakingUtils.ts';
import { UIUtilsEjsVariables } from '../../UIUtilsEjsVariables.ts';
import { MatchmakingCardCategory } from './ModeSelectorTypes.ts';
import { formatShuffleQueueTimeLeft } from '@colonist/clientforge';
import { SegmentedControl } from '@colonist/ui';
import { mountUIReactComponent } from '../../ui_platform/mountUIReactComponent.tsx';
import { getLobbyImagePath } from '../../ui_utils/Utils.ts';
import { UIModeSelectorBotMapController } from './UIModeSelectorBotMapController.ts';
import { sendBotsTabMembershipCTAClickedAnalytic, sendBotsTabRushDifficultySelectedAnalytic } from '../../analytics/sendBotsTabAnalytic.ts';
import { navigateToPage } from '../../ui_utils/ClientUtils.ts';
import { uiManagerEvents } from '../../EntryShared.ts';
import { isSubscriptionOverlayVariant } from '../../store/subscription_overlay/subscriptionOverlayABTest.ts';
export class UIModeSelectorController {
    onHomepageShow() {
        this.componentShownTimestamp = Date.now();
        this.startCnKCountdownTimer();
        this.startShuffleCountdownTimer();
    }
    selectTab(tab) {
        this.handleTabClick(tab);
    }
    selectCardByMatchType(matchType) {
        if (isBotDifficultyMatchType(matchType) && this.botDifficultyCard != undefined) {
            if (this.currentTab != MatchmakingCardCategory.Bots) this.handleTabClick(MatchmakingCardCategory.Bots);
            this.switchBotDifficulty(matchType);
            this.renderBotDifficultySegmentedControl(matchType);
            this.selectCard(this.botDifficultyCard);
            return;
        }
        const card = this.cards.find((c)=>c.data.matchType == matchType);
        if (card == undefined) return;
        if (card.data.category != this.currentTab) {
            this.handleTabClick(card.data.category);
        }
        this.selectCard(card);
    }
    async initCardsAndBadges() {
        this.createBotCards();
        await ClientUserState.waitUntilFresh;
        this.botMapController.update();
        this.createCasualCards();
        await this.createRankedCards();
        this.selectLastPlayedMatchmakingMode();
        this.startCnKCountdownTimer();
        this.startShuffleCountdownTimer();
        this.updateModeSelectorAdVisibility();
        this.resolveInitialized();
    }
    updateModeSelectorAdVisibility() {
        if (this.modeSelectorAd == null) return;
        this.modeSelectorAd.style.display = '';
        const activePanel = this.currentTab != undefined ? this.panels.get(this.currentTab) : undefined;
        if (activePanel == undefined) return;
        const isCardsScrolling = activePanel.scrollHeight > activePanel.clientHeight;
        if (isCardsScrolling) this.modeSelectorAd.style.display = 'none';
    }
    initTabClickHandlers() {
        setElementOnClick(this.botsTab, ()=>{
            this.handleTabClick(MatchmakingCardCategory.Bots);
        });
        setElementOnClick(this.casualTab, ()=>{
            this.handleTabClick(MatchmakingCardCategory.Casual);
        });
        setElementOnClick(this.rankedTab, ()=>{
            this.handleTabClick(MatchmakingCardCategory.Ranked);
        });
    }
    setupPlayButtonHandler() {
        setElementOnClick(this.playButton, ()=>{
            this.handlePlayButtonClick();
        });
    }
    addNewBadge(card, shouldShow) {
        UIModeSelectorController.addNewBadgeIfNeeded(card.element, shouldShow);
        const tab = this.getTabForCategory(card.data.category);
        UIModeSelectorController.addNewBadgeIfNeeded(tab, shouldShow, true);
    }
    getTabForCategory(category) {
        switch(category){
            case MatchmakingCardCategory.Bots:
                return this.botsTab;
            case MatchmakingCardCategory.Casual:
                return this.casualTab;
            case MatchmakingCardCategory.Ranked:
                return this.rankedTab;
        }
    }
    static shouldShowShuffleNewBadge() {
        var _ClientUserState_userState, _ClientShuffleQueueController_shufflePlayerData;
        const isLoggedIn = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn;
        const shuffleGamesPlayed = (_ClientShuffleQueueController_shufflePlayerData = ClientShuffleQueueController.shufflePlayerData) === null || _ClientShuffleQueueController_shufflePlayerData === void 0 ? void 0 : _ClientShuffleQueueController_shufflePlayerData.totalGameCount;
        return !(isLoggedIn && shuffleGamesPlayed != 0);
    }
    static shouldShowRushNewBadge() {
        return StorageWrapper.getRushGamesPlayed() == 0;
    }
    static addNewBadgeIfNeeded(parent, shouldShow, applyBadgeClass = false) {
        if (!shouldShow) return;
        const existingBadge = parent.querySelector('.badge-red');
        if (existingBadge != null) return;
        const isMobile = UIUtilsEjsVariables.isUserOnMobileAppOrWeb;
        const badge = createDivIn(parent, isMobile ? 'badge-red badge-sm' : 'badge-red badge-md');
        if (applyBadgeClass) badge.classList.add('badge');
        createParagraphIn(badge, {
            key: 'strings:homePage.matchmakingSelect.newBadge'
        }, '');
    }
    static getBotDifficultyIcon(matchType) {
        switch(matchType){
            case BotsMatchType.Easy:
                return LobbyImage.BotEasy;
            case BotsMatchType.Medium:
                return LobbyImage.BotMedium;
            case BotsMatchType.Hard:
                return LobbyImage.BotHard;
            default:
                return LobbyImage.BotEasy;
        }
    }
    createBotCards() {
        const beginnerCounts = getMatchTypePlayerAndBotCount(BotsMatchType.BeginnerMode);
        this.generateCard({
            icon: LobbyImage.BotBeginner,
            category: MatchmakingCardCategory.Bots,
            title: {
                key: 'strings:homePage.matchmakingSelect.cards.bots.beginner'
            },
            time: getMatchTypePlayTime(BotsMatchType.BeginnerMode),
            playerCount: beginnerCounts.playerCount,
            botCount: beginnerCounts.botCount,
            matchType: BotsMatchType.BeginnerMode
        });
        this.createBotDifficultyCard();
        const rushCounts = getMatchTypePlayerAndBotCount(BotsMatchType.ColonistRush);
        this.generateCard({
            icon: LobbyImage.GameModeBotRush,
            category: MatchmakingCardCategory.Bots,
            title: {
                key: 'strings:colonistCommon.gameModes.colonistRush.title'
            },
            time: getMatchTypePlayTime(BotsMatchType.ColonistRush),
            playerCount: rushCounts.playerCount,
            botCount: rushCounts.botCount,
            matchType: BotsMatchType.ColonistRush
        });
        this.rushBotCard = this.cards.find((card)=>card.data.matchType == BotsMatchType.ColonistRush);
        if (this.rushBotCard == undefined) return;
        this.addNewBadge(this.rushBotCard, UIModeSelectorController.shouldShowRushNewBadge());
        this.createRushDifficultySegmentedControl(this.rushBotCard);
    }
    createRushDifficultySegmentedControl(rushBotCard) {
        const segmentedControlContainer = createDivIn(rushBotCard.element, 'mm-mode-card-segmented-control', 'mm-rush-difficulty-segmented-control');
        UIModeSelectorBotMapController.stopCardChildPropagation(segmentedControlContainer);
        this.rushDifficultySegmentedControlView = mountUIReactComponent(segmentedControlContainer.id, SegmentedControl);
        this.renderRushDifficultySegmentedControl(StorageWrapper.getRushBotDifficulty());
    }
    renderRushDifficultySegmentedControl(activeDifficulty) {
        this.rushDifficultySegmentedControlView.render({
            size: 'md',
            activeId: activeDifficulty,
            options: UIModeSelectorController.getDifficultySegmentedControlOptions(BotDifficulty.BotEasy, BotDifficulty.BotMedium, BotDifficulty.BotHard),
            onTabChange: (id)=>this.switchRushDifficulty(id)
        });
    }
    switchRushDifficulty(difficulty) {
        if (this.rushBotCard != undefined && this.selectedCard != this.rushBotCard) this.selectCard(this.rushBotCard);
        StorageWrapper.setRushBotDifficulty(difficulty);
        sendBotsTabRushDifficultySelectedAnalytic(difficulty);
        this.renderRushDifficultySegmentedControl(difficulty);
    }
    createBotDifficultyCard() {
        const savedSelection = StorageWrapper.getLastSelectedMatchmakingMode();
        const initialMatchType = savedSelection != null && isBotDifficultyMatchType(savedSelection.matchType) ? savedSelection.matchType : BotsMatchType.Easy;
        const counts = getMatchTypePlayerAndBotCount(initialMatchType);
        const cardData = {
            icon: UIModeSelectorController.getBotDifficultyIcon(initialMatchType),
            category: MatchmakingCardCategory.Bots,
            title: {
                key: 'strings:homePage.matchmakingSelect.cards.bots.playVsBots'
            },
            time: getMatchTypePlayTime(initialMatchType),
            playerCount: counts.playerCount,
            botCount: counts.botCount,
            matchType: initialMatchType
        };
        this.generateCard(cardData);
        this.botDifficultyCard = this.cards[this.cards.length - 1];
        const segmentedControlContainer = createDivIn(this.botDifficultyCard.element, 'mm-mode-card-segmented-control', 'mm-bot-difficulty-segmented-control');
        UIModeSelectorBotMapController.stopCardChildPropagation(segmentedControlContainer);
        this.botDifficultySegmentedControlView = mountUIReactComponent(segmentedControlContainer.id, SegmentedControl);
        this.renderBotDifficultySegmentedControl(initialMatchType);
        this.botMapController = new UIModeSelectorBotMapController({
            parentCardElement: this.botDifficultyCard.element,
            shouldSelectBotDifficultyCard: ()=>this.botDifficultyCard != undefined && this.selectedCard != this.botDifficultyCard,
            selectBotDifficultyCard: ()=>{
                if (this.botDifficultyCard != undefined) this.selectCard(this.botDifficultyCard);
            },
            onSelectedMapChange: ()=>this.updateSelectedPlayButtonState()
        });
    }
    static getDifficultySegmentedControlOptions(easy, medium, hard) {
        return [
            {
                id: easy,
                label: {
                    key: 'strings:homePage.matchmakingSelect.cards.bots.easy'
                }
            },
            {
                id: medium,
                label: {
                    key: 'strings:homePage.matchmakingSelect.cards.bots.medium'
                }
            },
            {
                id: hard,
                label: {
                    key: 'strings:homePage.matchmakingSelect.cards.bots.hard'
                }
            }
        ];
    }
    renderBotDifficultySegmentedControl(activeMatchType) {
        this.botDifficultySegmentedControlView.render({
            size: 'md',
            activeId: activeMatchType,
            options: UIModeSelectorController.getDifficultySegmentedControlOptions(BotsMatchType.Easy, BotsMatchType.Medium, BotsMatchType.Hard),
            onTabChange: (id)=>{
                if (this.botDifficultyCard != undefined && this.selectedCard != this.botDifficultyCard) this.selectCard(this.botDifficultyCard);
                this.switchBotDifficulty(id);
            }
        });
    }
    switchBotDifficulty(matchType) {
        if (this.botDifficultyCard == undefined) return;
        const counts = getMatchTypePlayerAndBotCount(matchType);
        this.botDifficultyCard.data.matchType = matchType;
        this.botDifficultyCard.data.icon = UIModeSelectorController.getBotDifficultyIcon(matchType);
        this.botDifficultyCard.data.time = getMatchTypePlayTime(matchType);
        this.botDifficultyCard.data.playerCount = counts.playerCount;
        this.botDifficultyCard.data.botCount = counts.botCount;
        const iconElement = this.botDifficultyCard.element.querySelector('.mm-mode-card-icon');
        if (iconElement) iconElement.src = getLobbyImagePath(this.botDifficultyCard.data.icon);
        const detailsContainer = this.botDifficultyCard.element.querySelector('.mm-mode-card-details');
        if (this.botDifficultyCard.data.time != undefined) UIModeSelectorController.createOrUpdateTime(this.botDifficultyCard.element, detailsContainer, this.botDifficultyCard.data.time);
        UIModeSelectorController.createOrUpdatePlayerCount(this.botDifficultyCard.element, detailsContainer, counts.playerCount);
        UIModeSelectorController.createOrUpdateBotCount(this.botDifficultyCard.element, detailsContainer, counts.botCount);
        this.renderBotDifficultySegmentedControl(matchType);
        if (this.selectedCard == this.botDifficultyCard) {
            this.updatePlayButtonState(matchType);
            this.saveCurrentSelection();
        }
    }
    createCasualCards() {
        var _ClientShuffleQueueController_shuffleQueueData, _ClientUserState_userState;
        const shuffleDetails = getMatchTypeDetails(MatchmakingMatchTypes.UnrankedShuffle);
        const shuffleCounts = getMatchTypePlayerAndBotCount(MatchmakingMatchTypes.UnrankedShuffle);
        const casual1v1Counts = getMatchTypePlayerAndBotCount(MatchmakingMatchTypes.UnrankedClassic1v1);
        const casual4PlayerCounts = getMatchTypePlayerAndBotCount(MatchmakingMatchTypes.UnrankedClassic4P);
        const cards = [
            {
                card: {
                    icon: LobbyImage.GameMode1v1,
                    category: MatchmakingCardCategory.Casual,
                    title: {
                        key: 'strings:homePage.matchmakingSelect.cards.1v1'
                    },
                    time: getMatchTypePlayTime(MatchmakingMatchTypes.UnrankedClassic1v1),
                    playerCount: casual1v1Counts.playerCount,
                    botCount: casual1v1Counts.botCount,
                    matchType: MatchmakingMatchTypes.UnrankedClassic1v1
                }
            },
            {
                card: {
                    icon: LobbyImage.GameModeBase,
                    category: MatchmakingCardCategory.Casual,
                    title: {
                        key: 'strings:homePage.matchmakingSelect.cards.4Player'
                    },
                    time: getMatchTypePlayTime(MatchmakingMatchTypes.UnrankedClassic4P),
                    playerCount: casual4PlayerCounts.playerCount,
                    botCount: casual4PlayerCounts.botCount,
                    matchType: MatchmakingMatchTypes.UnrankedClassic4P
                }
            },
            {
                card: {
                    icon: LobbyImage.GameModeShuffle,
                    category: MatchmakingCardCategory.Casual,
                    title: {
                        key: 'strings:homePage.unranked.shuffle'
                    },
                    ...shuffleDetails.subtitle != undefined && {
                        subtitle: shuffleDetails.subtitle
                    },
                    ...shuffleDetails.description != undefined && {
                        description: shuffleDetails.description
                    },
                    ...shuffleDetails.showDescriptionLockIcon && {
                        showDescriptionLockIcon: shuffleDetails.showDescriptionLockIcon
                    },
                    time: getMatchTypePlayTime(MatchmakingMatchTypes.UnrankedShuffle),
                    playerCount: shuffleCounts.playerCount,
                    botCount: shuffleCounts.botCount,
                    nextRotationISO: (_ClientShuffleQueueController_shuffleQueueData = ClientShuffleQueueController.shuffleQueueData) === null || _ClientShuffleQueueController_shuffleQueueData === void 0 ? void 0 : _ClientShuffleQueueController_shuffleQueueData.endDate,
                    matchType: MatchmakingMatchTypes.UnrankedShuffle
                },
                ...shuffleDetails.badge && {
                    badge: shuffleDetails.badge
                },
                ...shuffleDetails.progressBar && {
                    progressBar: shuffleDetails.progressBar
                }
            }
        ];
        for (const { card, badge, progressBar } of cards){
            if (UIUtilsEjsVariables.shouldHideStoreOnMobile) {
                const cardsToHide = [
                    MatchmakingMatchTypes.UnrankedShuffle
                ];
                if (cardsToHide.includes(card.matchType)) continue;
            }
            this.generateCard(card, badge, progressBar);
        }
        var _ClientUserState_userState_totalCompletedGameCount;
        const hasPlayedEnoughGames = ((_ClientUserState_userState_totalCompletedGameCount = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.totalCompletedGameCount) !== null && _ClientUserState_userState_totalCompletedGameCount !== void 0 ? _ClientUserState_userState_totalCompletedGameCount : 0) >= RankedConstants.NumberOfGamesToUnlockRanked;
        const shuffleCard = this.cards.find((c)=>c.data.matchType == MatchmakingMatchTypes.UnrankedShuffle);
        if (shuffleCard == undefined) return;
        const shuffleQueueData = ClientShuffleQueueController.shuffleQueueData;
        if (shuffleQueueData && hasPlayedEnoughGames) {
            const iconElement = shuffleCard.element.querySelector('.mm-mode-card-icon');
            if (iconElement == undefined) return;
            const stackedIcon = createShuffleQueueIconStack(shuffleQueueData.mapId, shuffleQueueData.modeId);
            if (stackedIcon == undefined) return;
            stackedIcon.classList.add('mm-mode-card-icon');
            iconElement.replaceWith(stackedIcon);
        }
        this.addNewBadge(shuffleCard, UIModeSelectorController.shouldShowShuffleNewBadge());
    }
    async createRankedCards() {
        var _rankedCnKData_badge;
        const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiFindGameState(), undefined, undefined, false);
        if (response == undefined) return;
        if (!response.isSuccess) return;
        this.rankedStates = response.json;
        const ranked4PData = getMatchTypeDetails(MatchmakingMatchTypes.RankedClassic4P, this.rankedStates);
        const ranked1v1Data = getMatchTypeDetails(MatchmakingMatchTypes.RankedClassic1v1, this.rankedStates);
        const rankedCnKData = getMatchTypeDetails(MatchmakingMatchTypes.RankedCitiesAndKnights4P, this.rankedStates);
        const rankedRush4PData = getMatchTypeDetails(MatchmakingMatchTypes.RankedRush4P, this.rankedStates);
        const ranked1v1Counts = getMatchTypePlayerAndBotCount(MatchmakingMatchTypes.RankedClassic1v1);
        const ranked4PCounts = getMatchTypePlayerAndBotCount(MatchmakingMatchTypes.RankedClassic4P);
        const rankedCnKCounts = getMatchTypePlayerAndBotCount(MatchmakingMatchTypes.RankedCitiesAndKnights4P);
        const rankedRush4PCounts = getMatchTypePlayerAndBotCount(MatchmakingMatchTypes.RankedRush4P);
        const cards = [
            {
                card: {
                    icon: LobbyImage.GameModeRanked1v1,
                    category: MatchmakingCardCategory.Ranked,
                    title: {
                        key: 'strings:homePage.matchmakingSelect.cards.1v1'
                    },
                    ...ranked1v1Data.description && {
                        description: ranked1v1Data.description
                    },
                    ...ranked1v1Data.showDescriptionLockIcon && {
                        showDescriptionLockIcon: true
                    },
                    time: getMatchTypePlayTime(MatchmakingMatchTypes.RankedClassic1v1),
                    playerCount: ranked1v1Counts.playerCount,
                    botCount: ranked1v1Counts.botCount,
                    matchType: MatchmakingMatchTypes.RankedClassic1v1
                },
                ...ranked1v1Data.badge && {
                    badge: ranked1v1Data.badge
                },
                ...ranked1v1Data.progressBar && {
                    progressBar: ranked1v1Data.progressBar
                }
            },
            {
                card: {
                    icon: LobbyImage.GameModeRanked4P,
                    category: MatchmakingCardCategory.Ranked,
                    title: {
                        key: 'strings:homePage.matchmakingSelect.cards.4Player'
                    },
                    ...ranked4PData.description && {
                        description: ranked4PData.description
                    },
                    ...ranked4PData.showDescriptionLockIcon && {
                        showDescriptionLockIcon: true
                    },
                    time: getMatchTypePlayTime(MatchmakingMatchTypes.RankedClassic4P),
                    playerCount: ranked4PCounts.playerCount,
                    botCount: ranked4PCounts.botCount,
                    matchType: MatchmakingMatchTypes.RankedClassic4P
                },
                ...ranked4PData.badge && {
                    badge: ranked4PData.badge
                },
                ...ranked4PData.progressBar && {
                    progressBar: ranked4PData.progressBar
                }
            },
            {
                card: {
                    icon: LobbyImage.GameModeRankedRush,
                    category: MatchmakingCardCategory.Ranked,
                    title: {
                        key: 'strings:homePage.matchmakingSelect.cards.rush'
                    },
                    ...rankedRush4PData.description && {
                        description: rankedRush4PData.description
                    },
                    ...rankedRush4PData.showDescriptionLockIcon && {
                        showDescriptionLockIcon: true
                    },
                    time: getMatchTypePlayTime(MatchmakingMatchTypes.RankedRush4P),
                    playerCount: rankedRush4PCounts.playerCount,
                    botCount: rankedRush4PCounts.botCount,
                    matchType: MatchmakingMatchTypes.RankedRush4P
                },
                ...rankedRush4PData.badge && {
                    badge: rankedRush4PData.badge
                },
                ...rankedRush4PData.progressBar && {
                    progressBar: rankedRush4PData.progressBar
                }
            },
            {
                card: {
                    icon: LobbyImage.GameModeCnK,
                    category: MatchmakingCardCategory.Ranked,
                    title: {
                        key: 'strings:homePage.matchmakingSelect.cards.citiesAndKnights'
                    },
                    ...rankedCnKData.description && {
                        description: rankedCnKData.description
                    },
                    ...rankedCnKData.showDescriptionLockIcon && {
                        showDescriptionLockIcon: true
                    },
                    time: getMatchTypePlayTime(MatchmakingMatchTypes.RankedCitiesAndKnights4P),
                    playerCount: rankedCnKCounts.playerCount,
                    botCount: rankedCnKCounts.botCount,
                    matchType: MatchmakingMatchTypes.RankedCitiesAndKnights4P
                },
                ...rankedCnKData.badge && {
                    badge: rankedCnKData.badge
                },
                ...rankedCnKData.progressBar && {
                    progressBar: rankedCnKData.progressBar
                }
            }
        ];
        this.cnKProgressText = (_rankedCnKData_badge = rankedCnKData.badge) === null || _rankedCnKData_badge === void 0 ? void 0 : _rankedCnKData_badge.text;
        for (const { card, badge, progressBar } of cards){
            if (UIUtilsEjsVariables.shouldHideStoreOnMobile) {
                const cardsToHide = [
                    MatchmakingMatchTypes.RankedCitiesAndKnights4P
                ];
                if (cardsToHide.includes(card.matchType)) continue;
            }
            this.generateCard(card, badge, progressBar);
        }
        const rankedRushCard = this.cards.find((card)=>card.data.matchType == MatchmakingMatchTypes.RankedRush4P);
        if (rankedRushCard != undefined) this.addNewBadge(rankedRushCard, UIModeSelectorController.shouldShowRushNewBadge());
    }
    generateCard(cardData, badgeData, progressBarData) {
        const panel = this.panels.get(cardData.category);
        if (panel == undefined) return;
        const cardElement = createDivIn(panel, 'mm-mode-card');
        createImgIn(cardElement, cardData.icon, 'mm-mode-card-icon');
        const content = createDivIn(cardElement, 'mm-mode-card-content');
        const header = createDivIn(content, 'mm-mode-card-header');
        createHeaderIn(header, cardData.title, 'mm-mode-card-title');
        if (cardData.subtitle) createParagraphIn(header, cardData.subtitle, 'mm-mode-card-subtitle');
        if (cardData.description) {
            const descriptionElement = createParagraphIn(header, cardData.description, 'mm-mode-card-description');
            if (cardData.showDescriptionLockIcon) descriptionElement.prepend(createImgIn(descriptionElement, LobbyImage.LockOn, 'mm-mode-card-description-lock-icon'));
        }
        const details = createDivIn(content, 'mm-mode-card-details');
        if (cardData.time != undefined) UIModeSelectorController.createOrUpdateTime(cardElement, details, cardData.time);
        UIModeSelectorController.createOrUpdatePlayerCount(cardElement, details, cardData.playerCount);
        UIModeSelectorController.createOrUpdateBotCount(cardElement, details, cardData.botCount);
        UIModeSelectorController.setCardEligibility(cardElement, cardData);
        setElementOnClick(cardElement, ()=>{
            this.selectCard(card, true);
        });
        if (cardData.nextRotationISO != undefined) {
            const timeUntilRotationEnd = formatShuffleQueueTimeLeft(new Date(cardData.nextRotationISO));
            UIModeSelectorController.createOrUpdateCountdown(cardElement, details, timeUntilRotationEnd);
        }
        let progressBarElement;
        if (progressBarData != undefined) progressBarElement = new UIProgressBarElement(content, progressBarData);
        let badgeElement;
        if (badgeData != undefined) {
            const badgeParent = badgeData.placement == 'bottomRow' ? content : cardElement;
            badgeElement = new UIProgressBadgeElement(badgeParent, badgeData);
        }
        const infoIcon = createImgIn(cardElement, LobbyImage.InfoIcon, 'mm-mode-card-info-icon hidden');
        const card = {
            element: cardElement,
            data: cardData,
            ...badgeElement != undefined && {
                badge: badgeElement
            },
            ...progressBarElement != undefined && {
                progressBar: progressBarElement
            },
            infoIcon: infoIcon
        };
        this.cards.push(card);
    }
    static setCardEligibility(cardElement, card) {
        if (isBotMatchType(card.matchType)) return;
        const matchType = card.matchType;
        const { isEligible } = getMatchTypeEligibilityAndCreatePopup(matchType);
        cardElement.classList.toggle('disabled', !isEligible);
    }
    selectCard(card, isPhysicalClick = false) {
        var _this_selectedCard, _this_selectedCard1;
        (_this_selectedCard = this.selectedCard) === null || _this_selectedCard === void 0 ? void 0 : _this_selectedCard.element.classList.remove('selected');
        (_this_selectedCard1 = this.selectedCard) === null || _this_selectedCard1 === void 0 ? void 0 : _this_selectedCard1.infoIcon.classList.add('hidden');
        if (this.selectedCard == card && isPhysicalClick) this.onShowDetails(card.data.matchType, this.getBotMapSettingForMatchType(card.data.matchType));
        this.selectedCard = card;
        this.selectedCard.element.classList.add('selected');
        this.selectedCard.infoIcon.classList.remove('hidden');
        this.updatePlayButtonState(card.data.matchType);
        this.saveCurrentSelection();
    }
    handleTabClick(tab) {
        var _this_selectedCard;
        this.currentTab = tab;
        this.botsTab.classList.toggle('selected', this.currentTab == MatchmakingCardCategory.Bots);
        this.casualTab.classList.toggle('selected', this.currentTab == MatchmakingCardCategory.Casual);
        this.rankedTab.classList.toggle('selected', this.currentTab == MatchmakingCardCategory.Ranked);
        (_this_selectedCard = this.selectedCard) === null || _this_selectedCard === void 0 ? void 0 : _this_selectedCard.element.classList.remove('selected');
        this.slidingWrapper.setAttribute('data-active-tab', String(this.currentTab));
        this.selectFirstCardOfCurrentTab();
        this.saveCurrentSelection();
        this.updateModeSelectorAdVisibility();
    }
    selectFirstCardOfCurrentTab() {
        if (this.currentTab == undefined) this.selectTab(MatchmakingCardCategory.Bots);
        const firstCard = this.cards.find((card)=>card.data.category == this.currentTab);
        if (firstCard == undefined) return;
        this.selectCard(firstCard);
    }
    selectLastPlayedMatchmakingMode() {
        const savedSelection = StorageWrapper.getLastSelectedMatchmakingMode();
        var _savedSelection_category;
        this.handleTabClick((_savedSelection_category = savedSelection === null || savedSelection === void 0 ? void 0 : savedSelection.category) !== null && _savedSelection_category !== void 0 ? _savedSelection_category : MatchmakingCardCategory.Bots);
        void this.slidingWrapper.offsetWidth;
        this.slidingWrapper.classList.add('animated');
        this.tabsContainer.classList.add('animated');
        if (savedSelection == null) {
            this.selectFirstCardOfCurrentTab();
            return;
        }
        if (isBotDifficultyMatchType(savedSelection.matchType) && this.botDifficultyCard != undefined) {
            this.switchBotDifficulty(savedSelection.matchType);
            this.renderBotDifficultySegmentedControl(savedSelection.matchType);
            this.selectCard(this.botDifficultyCard);
            return;
        }
        const lastSelectedCard = this.cards.find((card)=>card.data.category == savedSelection.category && card.data.matchType == savedSelection.matchType);
        if (lastSelectedCard == undefined) {
            this.selectFirstCardOfCurrentTab();
            return;
        }
        this.selectCard(lastSelectedCard);
    }
    saveCurrentSelection() {
        var _this_selectedCard;
        const matchType = (_this_selectedCard = this.selectedCard) === null || _this_selectedCard === void 0 ? void 0 : _this_selectedCard.data.matchType;
        if (matchType == undefined) return;
        if (this.currentTab == undefined) return;
        StorageWrapper.setLastSelectedMatchmakingMode({
            category: this.currentTab,
            matchType: matchType
        });
    }
    redirectToCasualWithTransition(matchType) {
        this.playButton.classList.add('mm-button-transitioning');
        setElementInnerText(this.playButton, {
            key: 'strings:homePage.matchmakingSelect.switchingToCasual'
        });
        setTimeout(()=>{
            this.selectCardByMatchType(matchType);
            setElementInnerText(this.playButton, {
                key: 'strings:homePage.matchmakingSelect.switchingToCasual'
            });
        }, 300);
        setTimeout(()=>{
            var _this_selectedCard;
            this.playButton.classList.remove('mm-button-transitioning');
            const currentMatchType = (_this_selectedCard = this.selectedCard) === null || _this_selectedCard === void 0 ? void 0 : _this_selectedCard.data.matchType;
            if (currentMatchType != undefined) this.updatePlayButtonState(currentMatchType);
        }, 1000);
    }
    updateSelectedPlayButtonState() {
        var _this_selectedCard;
        const matchType = (_this_selectedCard = this.selectedCard) === null || _this_selectedCard === void 0 ? void 0 : _this_selectedCard.data.matchType;
        if (matchType == undefined) return;
        this.updatePlayButtonState(matchType);
    }
    updatePlayButtonState(matchType) {
        const shouldShowMembershipButton = this.shouldShowMembershipButtonForSelectedBotMap(matchType);
        updateMatchmakingPlayButtonState(this.playButton, matchType, {
            shouldShowMembershipButton: shouldShowMembershipButton,
            membershipButtonVariant: shouldShowMembershipButton ? 'premium' : 'plus'
        });
    }
    shouldShowMembershipButtonForSelectedBotMap(matchType) {
        if (!isBotDifficultyMatchType(matchType)) return false;
        return UIModeSelectorBotMapController.shouldShowMembershipButton(this.botMapController.getSelectedMapSetting());
    }
    handlePlayButtonClick() {
        var _this_selectedCard;
        const matchType = (_this_selectedCard = this.selectedCard) === null || _this_selectedCard === void 0 ? void 0 : _this_selectedCard.data.matchType;
        if (matchType == undefined) return;
        if (this.shouldShowMembershipButtonForSelectedBotMap(matchType)) {
            sendBotsTabMembershipCTAClickedAnalytic(this.botMapController.getSelectedMapSetting());
            if (isSubscriptionOverlayVariant()) uiManagerEvents.premiumMembershipCheckAction();
            else navigateToPage('/store', false, true);
            return;
        }
        if (isMatchTypeCasualLocked(matchType)) {
            const casualMatchType = getCasualRedirectMatchType(matchType);
            if (casualMatchType != undefined) this.redirectToCasualWithTransition(casualMatchType);
            return;
        }
        if (matchType == MatchmakingMatchTypes.RankedCitiesAndKnights4P) {
            const { state, eligibleRolls } = getClientCKRankedState();
            if (state == CKRankedState.CanRollDice) {
                showFreePlayDiceRollDialog(eligibleRolls);
                return;
            }
        }
        if (UIModeSelectorController.shouldShowRushRulesDialog(matchType)) {
            showRushRulesDialog(()=>this.startMatchmakingWithTracking(matchType));
            return;
        }
        this.startMatchmakingWithTracking(matchType);
    }
    static shouldShowRushRulesDialog(matchType) {
        const isRushMode = matchType == MatchmakingMatchTypes.RankedRush4P || matchType == BotsMatchType.ColonistRush;
        if (!isRushMode) return false;
        if (StorageWrapper.getRushGamesPlayed() != 0) return false;
        return getMatchTypeEligibilityAndCreatePopup(matchType).isEligible;
    }
    startMatchmakingWithTracking(matchType) {
        const gameModeString = getGameModeStringForAnalytics(matchType);
        if (!this.hasTrackedFirstQueueStart) {
            trackMatchmakingTimeToQueueStart(this.componentShownTimestamp, gameModeString);
            this.hasTrackedFirstQueueStart = true;
        }
        this.onStartGame(matchType, this.getBotMapSettingForMatchType(matchType));
    }
    getBotMapSettingForMatchType(matchType) {
        if (isBotDifficultyMatchType(matchType)) return this.botMapController.getSelectedMapSetting();
        return undefined;
    }
    resetRankedCards() {
        const rankedCards = this.cards.filter((card)=>card.data.category == MatchmakingCardCategory.Ranked);
        const ranked4PData = getMatchTypeDetails(MatchmakingMatchTypes.RankedClassic4P, this.rankedStates);
        const ranked1v1Data = getMatchTypeDetails(MatchmakingMatchTypes.RankedClassic1v1, this.rankedStates);
        const rankedCnKData = getMatchTypeDetails(MatchmakingMatchTypes.RankedCitiesAndKnights4P, this.rankedStates);
        const rankedRush4PData = getMatchTypeDetails(MatchmakingMatchTypes.RankedRush4P, this.rankedStates);
        rankedCards.forEach((card)=>{
            let rankedData;
            switch(card.data.matchType){
                case MatchmakingMatchTypes.RankedClassic4P:
                    rankedData = ranked4PData;
                    break;
                case MatchmakingMatchTypes.RankedClassic1v1:
                    rankedData = ranked1v1Data;
                    break;
                case MatchmakingMatchTypes.RankedCitiesAndKnights4P:
                    rankedData = rankedCnKData;
                    break;
                case MatchmakingMatchTypes.RankedRush4P:
                    rankedData = rankedRush4PData;
                    break;
                default:
                    return;
            }
            if (rankedData.subtitle != undefined) {
                card.data.subtitle = rankedData.subtitle;
                UIModeSelectorController.createOrUpdateSubtitle(card.element, rankedData.subtitle);
            }
            if (rankedData.description != undefined) {
                card.data.description = rankedData.description;
                card.data.showDescriptionLockIcon = rankedData.showDescriptionLockIcon;
                UIModeSelectorController.createOrUpdateDescription(card.element, rankedData.description, rankedData.showDescriptionLockIcon);
            } else if (card.data.description != undefined) {
                var _card_element_querySelector;
                card.data.description = undefined;
                card.data.showDescriptionLockIcon = undefined;
                (_card_element_querySelector = card.element.querySelector('.mm-mode-card-description')) === null || _card_element_querySelector === void 0 ? void 0 : _card_element_querySelector.remove();
            }
            if (rankedData.progressBar) UIModeSelectorController.updateCardProgressBar(card, rankedData.progressBar);
            UIModeSelectorController.updateCardBadge(card, rankedData.badge);
            if (card.data.matchType == MatchmakingMatchTypes.RankedCitiesAndKnights4P) {
                var _rankedData_badge;
                this.cnKProgressText = (_rankedData_badge = rankedData.badge) === null || _rankedData_badge === void 0 ? void 0 : _rankedData_badge.text;
                if (rankedData.badge != undefined) this.startCnKCountdownTimer();
            }
            UIModeSelectorController.setCardEligibility(card.element, card.data);
        });
    }
    startCnKCountdownTimer() {
        var _ClientUserState_userState, _ClientUserState_userState1, _ClientUserState_userState_ckFreeGameUntil, _ClientUserState_userState2, _ClientUserState_userState_ckNextRerollAt, _ClientUserState_userState3;
        if (this.cnKCountdownTimeout) clearTimeout(this.cnKCountdownTimeout);
        const doesUserHaveFreePlayFromDiceRoll = ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.ckFreeGameUntil) != undefined && ((_ClientUserState_userState1 = ClientUserState.userState) === null || _ClientUserState_userState1 === void 0 ? void 0 : _ClientUserState_userState1.ckFreeGameUntil.getTime()) > Date.now();
        this.cnKCountdownEndTimestamp = doesUserHaveFreePlayFromDiceRoll ? (_ClientUserState_userState2 = ClientUserState.userState) === null || _ClientUserState_userState2 === void 0 ? void 0 : (_ClientUserState_userState_ckFreeGameUntil = _ClientUserState_userState2.ckFreeGameUntil) === null || _ClientUserState_userState_ckFreeGameUntil === void 0 ? void 0 : _ClientUserState_userState_ckFreeGameUntil.getTime() : (_ClientUserState_userState3 = ClientUserState.userState) === null || _ClientUserState_userState3 === void 0 ? void 0 : (_ClientUserState_userState_ckNextRerollAt = _ClientUserState_userState3.ckNextRerollAt) === null || _ClientUserState_userState_ckNextRerollAt === void 0 ? void 0 : _ClientUserState_userState_ckNextRerollAt.getTime();
        this.scheduleCnKCountdownTick();
    }
    scheduleCnKCountdownTick() {
        if (!this.shouldUpdateCnKCardCountdownTimer()) return;
        this.cnKCountdownTimeout = setTimeout(()=>{
            this.updateCnKCardCountdownTimer();
            this.scheduleCnKCountdownTick();
        }, UIModeSelectorController.getAdaptiveIntervalMs(this.cnKCountdownEndTimestamp));
    }
    startShuffleCountdownTimer() {
        if (this.shuffleCountdownTimeout) clearTimeout(this.shuffleCountdownTimeout);
        this.scheduleShuffleCountdownTick();
    }
    scheduleShuffleCountdownTick() {
        if (!this.shouldUpdateShuffleCardCountdownTimer()) return;
        const shuffleCard = this.cards.find((card)=>card.data.category == MatchmakingCardCategory.Casual && card.data.matchType == MatchmakingMatchTypes.UnrankedShuffle);
        const shuffleEndMs = (shuffleCard === null || shuffleCard === void 0 ? void 0 : shuffleCard.data.nextRotationISO) != undefined ? new Date(shuffleCard.data.nextRotationISO).getTime() : undefined;
        this.shuffleCountdownTimeout = setTimeout(()=>{
            this.updateShuffleCardCountdownTimer();
            this.scheduleShuffleCountdownTick();
        }, UIModeSelectorController.getAdaptiveIntervalMs(shuffleEndMs));
    }
    static getAdaptiveIntervalMs(endTimestamp) {
        if (endTimestamp == undefined) return TimeUtils.MILLISECONDS;
        return TimeUtils.getAdaptiveCountdownPollIntervalMs(endTimestamp - Date.now());
    }
    updateCnKCardCountdownTimer() {
        const rankedCnKCard = this.cards.filter((card)=>card.data.category == MatchmakingCardCategory.Ranked).filter((card)=>card.data.matchType == MatchmakingMatchTypes.RankedCitiesAndKnights4P);
        if (rankedCnKCard.length == 0) return;
        if (this.cnKCountdownEndTimestamp == undefined) return;
        if (this.cnKCountdownEndTimestamp < Date.now()) {
            var _cnkRankedData_badge;
            const cnkRankedData = getMatchTypeDetails(MatchmakingMatchTypes.RankedCitiesAndKnights4P, this.rankedStates);
            this.cnKProgressText = (_cnkRankedData_badge = cnkRankedData.badge) === null || _cnkRankedData_badge === void 0 ? void 0 : _cnkRankedData_badge.text;
            this.resetRankedCards();
        }
        if (this.cnKProgressText == undefined) return;
        const timeUntilCountdownEnd = TimeUtils.formatCountdownString(new Date(this.cnKCountdownEndTimestamp));
        const progressElement = rankedCnKCard[0].element.querySelector('.mm-mode-card-progress p, .mm-mode-card-status-badge p');
        if (progressElement) setElementInnerText(progressElement, {
            key: this.cnKProgressText.key,
            options: {
                time: timeUntilCountdownEnd
            }
        });
    }
    shouldUpdateCnKCardCountdownTimer() {
        if (this.cnKCountdownEndTimestamp == undefined) return false;
        if (this.cnKCountdownEndTimestamp < Date.now()) return false;
        if (this.cnKProgressText == undefined) return false;
        if (this.cnKProgressText.key == 'strings:homePage.matchmakingSelect.freeGameFromDiceRoll') return true;
        if (this.cnKProgressText.key == 'strings:homePage.matchmakingSelect.dailyFreeRollWaiting') return true;
        return false;
    }
    updateShuffleCardCountdownTimer() {
        const shuffleCard = this.cards.find((card)=>card.data.category == MatchmakingCardCategory.Casual && card.data.matchType == MatchmakingMatchTypes.UnrankedShuffle);
        if (shuffleCard == undefined) return;
        if (shuffleCard.data.nextRotationISO == undefined) return;
        const rotationEndTimestamp = new Date(shuffleCard.data.nextRotationISO).getTime();
        const detailsContainer = shuffleCard.element.querySelector('.mm-mode-card-details');
        const timeUntilRotationEnd = formatShuffleQueueTimeLeft(new Date(rotationEndTimestamp));
        UIModeSelectorController.createOrUpdateCountdown(shuffleCard.element, detailsContainer, timeUntilRotationEnd);
    }
    shouldUpdateShuffleCardCountdownTimer() {
        const shuffleCard = this.cards.find((card)=>card.data.category == MatchmakingCardCategory.Casual && card.data.matchType == MatchmakingMatchTypes.UnrankedShuffle);
        if (shuffleCard == undefined) return false;
        if (shuffleCard.data.nextRotationISO == undefined) return false;
        const rotationEndTimestamp = new Date(shuffleCard.data.nextRotationISO).getTime();
        if (rotationEndTimestamp < Date.now()) return false;
        return true;
    }
    updateShuffleCard() {
        var _ClientUserState_userState;
        const shuffleCard = this.cards.find((card)=>card.data.category == MatchmakingCardCategory.Casual && card.data.matchType == MatchmakingMatchTypes.UnrankedShuffle);
        const shuffleQueueData = ClientShuffleQueueController.shuffleQueueData;
        if (shuffleCard == undefined || shuffleQueueData == undefined) return;
        const shuffleDetails = getMatchTypeDetails(MatchmakingMatchTypes.UnrankedShuffle);
        var _ClientUserState_userState_totalCompletedGameCount;
        const hasPlayedEnoughGames = ((_ClientUserState_userState_totalCompletedGameCount = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.totalCompletedGameCount) !== null && _ClientUserState_userState_totalCompletedGameCount !== void 0 ? _ClientUserState_userState_totalCompletedGameCount : 0) >= RankedConstants.NumberOfGamesToUnlockRanked;
        const iconElement = shuffleCard.element.querySelector('.mm-mode-card-icon');
        if (iconElement && hasPlayedEnoughGames) {
            const stackedIcon = createShuffleQueueIconStack(shuffleQueueData.mapId, shuffleQueueData.modeId);
            if (stackedIcon) {
                stackedIcon.classList.add('mm-mode-card-icon');
                iconElement.replaceWith(stackedIcon);
            }
        }
        const detailsContainer = shuffleCard.element.querySelector('.mm-mode-card-details');
        shuffleCard.data.time = getMatchTypePlayTime(MatchmakingMatchTypes.UnrankedShuffle);
        if (shuffleCard.data.time != undefined) UIModeSelectorController.createOrUpdateTime(shuffleCard.element, detailsContainer, shuffleCard.data.time);
        const playerAndBotCount = getMatchTypePlayerAndBotCount(MatchmakingMatchTypes.UnrankedShuffle);
        shuffleCard.data.playerCount = playerAndBotCount.playerCount;
        UIModeSelectorController.createOrUpdatePlayerCount(shuffleCard.element, detailsContainer, playerAndBotCount.playerCount);
        shuffleCard.data.botCount = playerAndBotCount.botCount;
        UIModeSelectorController.createOrUpdateBotCount(shuffleCard.element, detailsContainer, playerAndBotCount.botCount);
        if (shuffleDetails.subtitle != undefined) {
            shuffleCard.data.subtitle = shuffleDetails.subtitle;
            UIModeSelectorController.createOrUpdateSubtitle(shuffleCard.element, shuffleDetails.subtitle);
        }
        if (shuffleDetails.description != undefined) {
            shuffleCard.data.description = shuffleDetails.description;
            shuffleCard.data.showDescriptionLockIcon = shuffleDetails.showDescriptionLockIcon;
            UIModeSelectorController.createOrUpdateDescription(shuffleCard.element, shuffleDetails.description, shuffleDetails.showDescriptionLockIcon);
        } else if (shuffleCard.data.description != undefined) {
            var _shuffleCard_element_querySelector;
            shuffleCard.data.description = undefined;
            shuffleCard.data.showDescriptionLockIcon = undefined;
            (_shuffleCard_element_querySelector = shuffleCard.element.querySelector('.mm-mode-card-description')) === null || _shuffleCard_element_querySelector === void 0 ? void 0 : _shuffleCard_element_querySelector.remove();
        }
        if (shuffleDetails.progressBar) UIModeSelectorController.updateCardProgressBar(shuffleCard, shuffleDetails.progressBar);
        UIModeSelectorController.updateCardBadge(shuffleCard, shuffleDetails.badge);
        if (shuffleQueueData.endDate) {
            shuffleCard.data.nextRotationISO = shuffleQueueData.endDate;
            const timeUntilRotationEnd = formatShuffleQueueTimeLeft(new Date(shuffleQueueData.endDate));
            UIModeSelectorController.createOrUpdateCountdown(shuffleCard.element, detailsContainer, timeUntilRotationEnd);
            this.startShuffleCountdownTimer();
        }
        if (this.selectedCard == shuffleCard) this.updatePlayButtonState(shuffleCard.data.matchType);
        UIModeSelectorController.setCardEligibility(shuffleCard.element, shuffleCard.data);
        this.addNewBadge(shuffleCard, UIModeSelectorController.shouldShowShuffleNewBadge());
    }
    static updateCardBadge(card, badgeData) {
        if (badgeData == undefined) {
            var _card_badge;
            (_card_badge = card.badge) === null || _card_badge === void 0 ? void 0 : _card_badge.remove();
            card.badge = undefined;
            return;
        }
        const badgeParent = badgeData.placement == 'bottomRow' ? card.element.querySelector('.mm-mode-card-content') : card.element;
        if (card.badge == undefined) {
            card.badge = new UIProgressBadgeElement(badgeParent, badgeData);
            return;
        }
        card.badge.update(badgeData);
    }
    static updateCardProgressBar(card, progressBarData) {
        const content = card.element.querySelector('.mm-mode-card-content');
        if (card.progressBar == undefined) {
            card.progressBar = new UIProgressBarElement(content, progressBarData);
            return;
        }
        card.progressBar.update(progressBarData);
    }
    static createOrUpdateTime(cardElement, detailsContainer, time) {
        const existingElement = cardElement.querySelector('.mm-mode-card-time p');
        if (existingElement) {
            setElementInnerText(existingElement, {
                key: 'strings:colonistCommon.utils.#buffer',
                options: {
                    value: time.toString()
                }
            });
            return;
        }
        const timeDiv = createDivIn(detailsContainer, 'mm-mode-card-detail mm-mode-card-time');
        createExternalImgIn(timeDiv, IconPlayTime, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: time.toString()
            }
        });
        createParagraphIn(timeDiv, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: time.toString()
            }
        }, '');
    }
    static createOrUpdatePlayerCount(cardElement, detailsContainer, playerCount) {
        const existingElement = cardElement.querySelector('.mm-mode-card-player-count p');
        if (existingElement) {
            setElementInnerText(existingElement, {
                key: 'strings:colonistCommon.utils.#buffer',
                options: {
                    value: playerCount.toString()
                }
            });
            return;
        }
        const playerCountDiv = createDivIn(detailsContainer, 'mm-mode-card-detail mm-mode-card-player-count');
        createExternalImgIn(playerCountDiv, IconPlayerCount, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: playerCount.toString()
            }
        });
        createParagraphIn(playerCountDiv, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: playerCount.toString()
            }
        }, '');
    }
    static createOrUpdateBotCount(cardElement, detailsContainer, botCount) {
        const isHidden = botCount <= 0;
        const existingElement = cardElement.querySelector('.mm-mode-card-bot-count p');
        if (existingElement) {
            var _existingElement_parentElement;
            setElementInnerText(existingElement, {
                key: 'strings:colonistCommon.utils.#buffer',
                options: {
                    value: botCount.toString()
                }
            });
            (_existingElement_parentElement = existingElement.parentElement) === null || _existingElement_parentElement === void 0 ? void 0 : _existingElement_parentElement.classList.toggle('hidden', isHidden);
            return;
        }
        const botCountDiv = createDivIn(detailsContainer, 'mm-mode-card-detail mm-mode-card-bot-count');
        createExternalImgIn(botCountDiv, IconBotCount, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: botCount.toString()
            }
        });
        createParagraphIn(botCountDiv, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: botCount.toString()
            }
        }, '');
        botCountDiv.classList.toggle('hidden', isHidden);
    }
    static createOrUpdateCountdown(cardElement, detailsContainer, countdownText) {
        const existingElement = cardElement.querySelector('.mm-mode-card-countdown p');
        if (existingElement) {
            setElementInnerText(existingElement, countdownText);
            return;
        }
        const countdown = createDivIn(detailsContainer, 'mm-mode-card-detail mm-mode-card-countdown');
        createImgIn(countdown, LobbyImage.IconRotation, 'mm-mode-card-detail-icon');
        createParagraphIn(countdown, countdownText, '');
    }
    static createOrUpdateSubtitle(cardElement, subtitle) {
        const existingElement = cardElement.querySelector('.mm-mode-card-subtitle');
        if (existingElement) {
            setElementInnerText(existingElement, subtitle);
            return;
        }
        const header = cardElement.querySelector('.mm-mode-card-header');
        const subtitleElement = createParagraphIn(header, subtitle, 'mm-mode-card-subtitle');
        const descriptionElement = cardElement.querySelector('.mm-mode-card-description');
        if (descriptionElement) header.insertBefore(subtitleElement, descriptionElement);
    }
    static createOrUpdateDescription(cardElement, description, showLockIcon) {
        const existingElement = cardElement.querySelector('.mm-mode-card-description');
        if (existingElement) {
            setElementInnerText(existingElement, description);
            if (showLockIcon) existingElement.prepend(createImgIn(existingElement, LobbyImage.LockOn, 'mm-mode-card-description-lock-icon'));
            return;
        }
        const header = cardElement.querySelector('.mm-mode-card-header');
        const descriptionElement = createParagraphIn(header, description, 'mm-mode-card-description');
        if (showLockIcon) descriptionElement.prepend(createImgIn(descriptionElement, LobbyImage.LockOn, 'mm-mode-card-description-lock-icon'));
    }
    constructor(initTimestamp, onStartGame, onShowDetails){
        this.cards = [];
        this.hasTrackedFirstQueueStart = false;
        this.rankedStates = [];
        this.onStartGame = onStartGame;
        this.onShowDetails = onShowDetails;
        const deferredPromise = createDeferredPromise();
        this.waitUntilInitialized = deferredPromise;
        this.resolveInitialized = deferredPromise.resolve;
        this.cardsContainer = document.getElementById('mm-mode-cards-container');
        this.playButton = document.getElementById('mm-mode-card-button');
        this.tabsContainer = document.getElementById('mm-mode-tabs');
        this.botsTab = document.getElementById('mm-mode-tab-bots');
        this.casualTab = document.getElementById('mm-mode-tab-casual');
        this.rankedTab = document.getElementById('mm-mode-tab-ranked');
        this.modeSelectorAd = document.getElementById('mm-mode-selector-ad');
        this.slidingWrapper = createDivIn(this.cardsContainer, 'mm-mode-cards-slider');
        this.panels = new Map([
            [
                MatchmakingCardCategory.Bots,
                createDivIn(this.slidingWrapper, 'mm-mode-cards-panel')
            ],
            [
                MatchmakingCardCategory.Casual,
                createDivIn(this.slidingWrapper, 'mm-mode-cards-panel')
            ],
            [
                MatchmakingCardCategory.Ranked,
                createDivIn(this.slidingWrapper, 'mm-mode-cards-panel')
            ]
        ]);
        this.componentShownTimestamp = initTimestamp;
        this.initTabClickHandlers();
        this.setupPlayButtonHandler();
        void this.initCardsAndBadges();
        ClientUserState.registerChangeListener(()=>{
            this.resetRankedCards();
            this.updateShuffleCard();
            this.botMapController.update();
            this.updateSelectedPlayButtonState();
        });
        ClientShuffleQueueController.registerChangeListener(()=>{
            this.updateShuffleCard();
        });
    }
}
